
{
  "familyId": "GET-PROC-TOENAME",
  "questions": [
    {
      "id": "GET-PROC-TOENAME-001",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een fietsenmaker verkoopt een fiets voor €400. De prijs stijgt met 15%. Wat is de nieuwe prijs?",
      "options": [
        "€460",
        "€415",
        "€340",
        "€600"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 15,
            "label": "15% toename op €400 → €60 erbij, €460 totaal",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 15% prijstoename" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Procentuele toename uitgesplitst",
            "content": "Oude prijs (100%): €400. Toename (15%): €60. Nieuwe prijs: €400 + €60 = €460.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_prijs",
      "variantIndex": 1,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Je berekent eerst de toename: 15% van €400 = 0,15 × 400 = €60. Daarna tel je op bij de oorspronkelijke prijs: €400 + €60 = €460. Je kunt ook direct rekenen met de groeifactor: €400 × 1,15 = €460.",
        "solutionSteps": [
          "Bereken de toename: 15% van €400 = 0,15 × 400 = €60",
          "Tel op bij het oorspronkelijke bedrag: €400 + €60 = €460",
          "Check met factor: €400 × 1,15 = €460 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 15% van 400 = 60. Nieuwe prijs: 400 + 60 = €460.",
          "1": "Je dacht waarschijnlijk dat je 15 optelt bij de prijs. Maar 15% van 400 = 60, niet 15. Onthoud: je moet het percentage berekenen: 0,15 × 400 = 60.",
          "2": "Je dacht waarschijnlijk dat je moet aftrekken. Maar bij een stijging tel je op: 400 + 60 = 460, niet 400 − 60 = 340. Onthoud: stijging = optellen, daling = aftrekken.",
          "3": "Je dacht waarschijnlijk dat 15% = 0,5. Maar 15% = 0,15, dus de factor is 1,15, niet 1,5. Onthoud: 400 × 1,15 = 460, niet 400 × 1,5 = 600."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-002",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een stadsplanner meldt dat een stad met 80.000 inwoners 5% is gegroeid. Hoeveel inwoners zijn er nu?",
      "options": [
        "84.000",
        "80.500",
        "85.000",
        "120.000"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 5,
            "label": "5% groei op 80.000 → 4.000 erbij, 84.000 totaal",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 5% bevolkingsgroei" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bevolkingsgroei uitgesplitst",
            "content": "Oorspronkelijk (100%): 80.000 inwoners. Groei (5%): 4.000 inwoners erbij. Nieuwe stand: 80.000 + 4.000 = 84.000.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_bevolking",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Je berekent 5% van 80.000: dat is 0,05 × 80.000 = 4.000 inwoners erbij. Het nieuwe inwoneraantal: 80.000 + 4.000 = 84.000. Je kunt ook direct rekenen: 80.000 × 1,05 = 84.000.",
        "solutionSteps": [
          "Bereken de toename: 5% van 80.000 = 0,05 × 80.000 = 4.000",
          "Tel op: 80.000 + 4.000 = 84.000",
          "Check met factor: 80.000 × 1,05 = 84.000 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 5% van 80.000 = 4.000. Nieuw: 80.000 + 4.000 = 84.000.",
          "1": "Je dacht waarschijnlijk dat je 500 optelt. Maar 5% van 80.000 = 4.000, niet 500. Onthoud: 0,05 × 80.000 = 4.000.",
          "2": "Je dacht waarschijnlijk dat je 5.000 optelt. Maar 5% ≠ 5.000. Onthoud: bereken het percentage: 0,05 × 80.000 = 4.000.",
          "3": "Je dacht waarschijnlijk dat de factor 1,5 is. Maar 5% = 0,05, dus de factor is 1,05, niet 1,5. Onthoud: 80.000 × 1,05 = 84.000, niet 80.000 × 1,5 = 120.000."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-003",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een econoom berekent de groeifactor. Met welke factor vermenigvuldig je bij een toename van 25%?",
      "options": [
        "1,25",
        "0,25",
        "1,025",
        "25"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 25,
            "label": "25% toename → groeifactor 1 + 0,25 = 1,25",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 25% groei, factor 1,25" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Groeifactor 1,25 = 125%",
            "content": "Origineel = 100%. Toename = 25%. Samen: 100% + 25% = 125%, oftewel factor 1,25.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_factor",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "De groeifactor bereken je door het percentage als decimaal op te tellen bij 1. Bij 25% toename: 25% = 0,25. Factor = 1 + 0,25 = 1,25. Met deze factor vermenigvuldig je het oorspronkelijke bedrag om de nieuwe waarde te krijgen.",
        "solutionSteps": [
          "Zet het percentage om naar een decimaal: 25% = 0,25",
          "Tel op bij 1: factor = 1 + 0,25 = 1,25",
          "Check: 1,25 = 125% → 25% meer dan het origineel ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Toename van 25% → factor = 1 + 0,25 = 1,25.",
          "1": "Je dacht waarschijnlijk dat het percentage zelf de factor is. Maar 0,25 is alleen de toename, niet de factor. Onthoud: factor = 1 + 0,25 = 1,25 (je houdt het oorspronkelijke bedrag erbij).",
          "2": "Je dacht waarschijnlijk dat 25% = 0,025. Maar 25% = 0,25 (deel door 100, niet door 1000). Onthoud: 2,5% = 0,025, maar 25% = 0,25.",
          "3": "Je dacht waarschijnlijk dat het percentage zelf als factor werkt. Maar 25 is geen bruikbare factor — je moet het eerst omzetten naar een decimaal. Onthoud: 25% = 0,25, factor = 1,25."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-004",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een bankmedewerker berekent de rente. Een spaarrekening van €2.000 groeit met 3,5% rente. Hoeveel staat er na één jaar?",
      "options": [
        "€2.070",
        "€2.035",
        "€2.700",
        "€2.350"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 3.5,
            "label": "3,5% rente op €2.000 → €70 erbij, €2.070 totaal",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 3,5% rente" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rente uitgesplitst",
            "content": "Inleg (100%): €2.000. Rente (3,5%): €70. Eindsaldo: €2.000 + €70 = €2.070.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_rente",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Je berekent de rente: 3,5% van €2.000 = 0,035 × 2.000 = €70. Het nieuwe saldo: €2.000 + €70 = €2.070. Let op de komma in het percentage: 3,5% = 0,035, niet 0,35.",
        "solutionSteps": [
          "Zet het percentage om: 3,5% = 0,035",
          "Bereken de rente: 0,035 × €2.000 = €70",
          "Tel op: €2.000 + €70 = €2.070"
        ],
        "distractorExplanations": {
          "0": "Goed! 3,5% van 2.000 = 70. Na één jaar: 2.000 + 70 = €2.070.",
          "1": "Je dacht waarschijnlijk dat je 35 optelt. Maar 3,5% van 2.000 = 70, niet 35. Onthoud: 3,5% = 0,035, en 0,035 × 2.000 = 70.",
          "2": "Je dacht waarschijnlijk dat 3,5% = 35%. Maar 35% van 2.000 = 700, terwijl 3,5% van 2.000 = 70. Onthoud: let goed op de komma in het percentage.",
          "3": "Je dacht waarschijnlijk dat de factor 1,35 is. Maar 3,5% = 0,035, dus de factor = 1,035, niet 1,35. Onthoud: 2.000 × 1,035 = 2.070, niet 2.000 × 1,35 = 2.350."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-005",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "fill_in",
      "question": "Een horecaondernemer verhoogt de menuprijs van €12 met 10%. Wat is de nieuwe prijs in euro's?",
      "correctAnswer": "13,20",
      "data": {
        "acceptedAnswers": ["13,20", "13.20", "€13,20", "€ 13,20", "13,2"],
        "placeholder": "€ ...",
        "inputType": "text"
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 10,
            "label": "10% prijsverhoging op €12 → €1,20 erbij, €13,20 totaal",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: 10% prijsverhoging" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Prijsverhoging uitgesplitst",
            "content": "Oude prijs (100%): €12. Verhoging (10%): €1,20. Nieuwe prijs: €12 + €1,20 = €13,20.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_menuprijs",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Je berekent de verhoging: 10% van €12 = 0,10 × 12 = €1,20. De nieuwe prijs: €12 + €1,20 = €13,20. Je kunt ook direct rekenen: €12 × 1,10 = €13,20. Let op: het antwoord heeft twee decimalen omdat het een geldbedrag is.",
        "solutionSteps": [
          "Bereken de verhoging: 10% van €12 = 0,10 × 12 = €1,20",
          "Tel op: €12 + €1,20 = €13,20",
          "Check met factor: €12 × 1,10 = €13,20 ✓"
        ]
      }
    },
    {
      "id": "GET-PROC-TOENAME-006",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "comparison_judge",
      "question": "Twee winkels passen een prijsverhoging toe op een artikel van €200. Winkel A verhoogt met 20%. Winkel B verhoogt eerst met 10% en daarna nog eens met 10%. Welke aanpak geeft de hoogste eindprijs?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "B", "content": "Winkel B: €200 × 1,10 × 1,10 = €242 (10% boven 10% van een nieuwe basis)" },
            { "id": "A", "content": "Winkel A: €200 × 1,20 = €240 (eenmalig 20% toename)" },
            { "id": "gelijk", "content": "Beide winkels: €240 (10% + 10% = 20%)" }
          ],
          "criterion": "Welke berekening geeft de hoogste eindprijs?",
          "correctIndex": 0
        }
      },
      "stimulusAids": [
        {
          "type": "percentageBar",
          "data": {
            "percentage": 20,
            "label": "Vergelijk: één keer 20% vs. twee keer 10%",
            "showValue": true
          },
          "a11y": { "alt": "Percentagebalk: vergelijking van procentuele toenames" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee keer 10% — de tweede 10% rekent over de nieuwe waarde",
            "content": "Stap 1 (100%): €200. +10% van €200 = €20 → €220. +10% van €220 = €22 → €242. De tweede 10% telt over een nieuwe basis, dus uitkomst is hoger dan eenmalig 20%.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_samengesteld_vergelijk",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.proc-samengesteld-optellen", "label": "Telt percentages op alsof ze additief zijn", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Twee keer 10% is niet hetzelfde als één keer 20%. Bij de tweede verhoging reken je over de nieuwe waarde (€220), dus krijg je €22 erbij in plaats van €20. Resultaat: €200 × 1,10 × 1,10 = €242. Winkel A: €200 × 1,20 = €240. Verschil: €2. Procenten zijn niet additief — dit heet samengestelde groei.",
        "solutionSteps": [
          "Winkel A: €200 × 1,20 = €240",
          "Winkel B stap 1: €200 + 10% = €220",
          "Winkel B stap 2: €220 + 10% van 220 = €220 + €22 = €242",
          "Vergelijk: €242 > €240 → Winkel B is duurder"
        ]
      }
    }
  ]
}
